import documentService from '@/http/services/document'
import store from '../../../store'
export default {
  getDriverDocuments ({ commit }, driverId) {
    return documentService.getDriverDocuments(store.state.apiUrl, driverId).then((response) => {
      commit('setDriverDocuments', response.data)
    })
  },
  getTaxiDocuments ({ commit }, taxiId) {
    return documentService.getTaxiDocuments(store.state.apiUrl, taxiId).then((response) => {
      commit('setTaxiDocuments', response.data)
    })
  }
}
